import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from '@material-ui/core/styles/withStyles';
import { ADGMImage } from 'aurora-components';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import CheckCircle from '@material-ui/icons/CheckCircle';
import classNames from 'classnames';
import truncate from 'lodash/truncate';
// import { FRESH_DESK_URL } from 'aurora-utils/constants';
import { keyEmptyCheck } from 'aurora-utils/utils';
import dummy from 'aurora-api/dummy/dummyContents';
import link from 'aurora-api/ui/link';
import messages from 'aurora-translations';

import ProfileSwitch from './ProfileSwitch';
import ADGMModal from '../ADGMModal';
import './navigation.css';

// const { HELP_URL } = FRESH_DESK_URL;
function UserMenu(props) {
  const { classes, signOut, name } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenu = menu => event => {
    setOpenMenu(openMenu === menu ? null : menu);
    setAnchorEl(event.currentTarget);
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(null);
  };

  // const helpHandler = () => {
  //   window.open(`${HELP_URL}/${localStorage.getItem('lang')}/support/home`, '_blank');
  // };
  const companyUserRole = localStorage.getItem('companyUserRole');

  // eslint-disable-next-line no-unused-vars
  let loggedInUser = null;
  if (localStorage.getItem('selectedAccount')) {
    const adddata = localStorage?.selectedAccount;
    loggedInUser = JSON.parse(adddata);
  }

  return (
    <div>
      <Menu
        id='menu-notification'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={classes.notificationMenu}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        open={openMenu === 'notification'}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <div>
            <ListItemAvatar>
              <Avatar>
                <CheckCircle />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={dummy.text.subtitle}
              className={classes.textNotification}
              secondary={dummy.text.date}
            />
          </div>
        </MenuItem>
      </Menu>
      <Button onClick={handleMenu('user-setting')} className={classes.loginBtn}>
        <ADGMImage
          name={companyUserRole !== 'owner' ? 'avatar_profile.svg' : 'Company_avatar.svg'}
          className={classes.avatar}
        />

        <div className={classes.profileDescriptionLayout}>
          <span className={classes.userName}>
            {truncate(name, {
              length: 15,
            })}
          </span>

          <span className={classes.userType}>
            {localStorage.getItem('userType') && localStorage.getItem('userType') !== 'undefined' ? (
              keyEmptyCheck(localStorage.getItem('userType'))
            ) : (
              <FormattedMessage {...messages.profileSwitcher} />
            )}
            <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
              <g clipPath='url(#clip0_3036_30994)'>
                <path
                  d='M0.270508 2.81348L5.83301 9.09998C5.85647 9.1265 5.88529 9.14773 5.91757 9.16227C5.94985 9.17681 5.98485 9.18433 6.02026 9.18433C6.05566 9.18433 6.09066 9.17681 6.12294 9.16227C6.15523 9.14773 6.18405 9.1265 6.20751 9.09998L11.7705 2.81348'
                  stroke='black'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <defs>
                <clipPath id='clip0_3036_30994'>
                  <rect width='12' height='12' fill='white' />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
      </Button>
      <Menu
        id='menu-appbar'
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openMenu === 'user-setting'}
        onClose={handleClose}
      >
        <MenuItem
          className={classNames(classes.professionalPopupOpener, classes.userSubmenuitem)}
          onClick={toggleModal}
        >
          <svg width='24' height='24' viewBox='0 0 24 24' aria-hidden='true'>
            <path d='M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' />
          </svg>
          <FormattedMessage {...messages.switch_to_Professional} />
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose} component={Link} to={link.profile} className={classes.userSubmenuitem}>
          <FormattedMessage {...messages.my_profile} />
        </MenuItem>

        {loggedInUser?.isDeveloper && (
          <MenuItem onClick={handleClose} component={Link} to={link.my_projects} className={classes.userSubmenuitem}>
            <FormattedMessage {...messages.my_projects} />
          </MenuItem>
        )}

        <MenuItem onClick={handleClose} component={Link} to={link.primaryContact} className={classes.userSubmenuitem}>
          <FormattedMessage {...messages.primary_contact_details} />
        </MenuItem>

        <MenuItem
          onClick={handleClose}
          component={Link}
          to={link.walletAndPayments}
          className={classes.userSubmenuitem}
        >
          <FormattedMessage {...messages.my_wallets_payments} />
        </MenuItem>
        {/* <MenuItem onClick={handleClose} component={Link} to={link.documents} className={classes.userSubmenuitem}>
          <FormattedMessage {...messages.my_documents} />
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to={link.notifications} className={classes.userSubmenuitem}>
          <FormattedMessage {...messages.notification} />
        </MenuItem> */}
        {companyUserRole && companyUserRole === 'owner' && (
          <MenuItem onClick={handleClose} component={Link} to='/app/user/employees' className={classes.userSubmenuitem}>
            <FormattedMessage {...messages.employees_management} />
          </MenuItem>
        )}
        <Divider />
        {/* <MenuItem className={classes.userSubmenuitem} onClick={helpHandler}>
          <FormattedMessage {...messages.help_support} />
        </MenuItem> */}
        {/* <MenuItem className={classes.userSubmenuitem} component={Link} to='/app/term-and-condition'>
          <FormattedMessage {...messages.terms_conditions} />
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={signOut} className={classes.userSubmenuitem}>
          <FormattedMessage {...messages.logout} />
        </MenuItem>
      </Menu>
      <ADGMModal open={isModalOpen} className={classes.switchModal} toggleModal={toggleModal}>
        <ProfileSwitch
          title={<FormattedMessage {...messages.switch_to_professional_title} />}
          data='Don’t have an account?'
          toggleModal={toggleModal}
        />
      </ADGMModal>
    </div>
  );
}

UserMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  signOut: PropTypes.func.isRequired,
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

const styles = theme => ({
  userSubmenuitem: {
    borderTop: '1px solid rgba(235, 238, 243, 0.5)',

    padding: '16px',

    fontWeight: '500',

    fontSize: '14px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  professionalPopupOpener: {
    fontWeight: '600',

    color: theme.palette.primary.main,
  },
  notificationMenu: {
    '& li': {
      height: 'auto',
      '& h3': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
  },
  textNotification: {
    '& span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  },
  profileDescriptionLayout: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
  },
  userName: {
    color: theme.palette.primary.foreground,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    textTransform: 'capitalize',
    maxWidth: '140px',
  },
  userType: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '14px',
    fontstyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    textTransform: 'capitalize',
    '& svg': {
      marginLeft: '3px',
    },
  },
  loginBtn: {
    '& img': {
      width: '40px',
    },
  },
  switchModal: {
    padding: '20px',
  },
  avatar: {
    marginRight: '6px',
  },
});

export default withStyles(styles)(injectIntl(UserMenu));
